import { render, staticRenderFns } from "./NgTextKeyboard.vue?vue&type=template&id=61bdfce4"
import script from "./NgTextKeyboard.vue?vue&type=script&lang=js"
export * from "./NgTextKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports